// extracted by mini-css-extract-plugin
module.exports = {"Column":"Column__ni9ZD"};